<template>
  <div v-if="!$store.state.loading.general && !$route.meta.noNav">
    <v-menu offset-y top :close-on-content-click="false" v-model="menu">
      <template v-slot:activator="{ props }">
        <v-btn
          color="error"
          dark
          v-bind="props"
          class="feed primary--text"
          tile
          style="font-size: 9pt"
        >
          Feedback
        </v-btn>
      </template>
      <div class="pa-6 bg-primary" style="width: 400px">
        <v-select
          variant="solo"
          flat
          bg-color="smoke"
          label="Type of feedback"
          :items="items"
          hide-details=""
          style="border-radius: 6px"
          v-model="type"
          class="mb-4"
        ></v-select
        ><v-select
          variant="solo"
          v-if="userProfile?.superadmin"
          flat
          bg-color="smoke"
          label="Type of feedback"
          :items="states"
          hide-details=""
          style="border-radius: 6px"
          v-model="state"
          class="mb-4"
        ></v-select>
        <v-text-field
          v-if="
            this.$store.state.users.userProfile &&
            this.$store.state.users.userProfile.superadmin
          "
          v-model="title"
          placeholder="Title here.."
          flat
          variant="solo"
          style="border-radius: 6px"
          hide-details=""
          class="mb-2"
          bg-color="smoke"
        ></v-text-field>
        <v-textarea
          bg-color="smoke"
          variant="solo"
          flat
          v-model="message"
          style="border-radius: 6px"
          placeholder="Type your feedback here.."
        ></v-textarea>
        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn
            elevation="0"
            color="button"
            class="primary--text"
            :loading="saving"
            @click="saveFeedback"
            >Send</v-btn
          >
        </div>
      </div>
    </v-menu>
  </div>
</template>

<script>
import { collection, addDoc, doc, updateDoc } from "firebase/firestore";
import { db } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      workspace: (state) => state.workspace.workspace,
      accounts: (state) => state.accounts.accounts,
      categories: (state) => state.posts.categories,
    }),
  },
  data() {
    return {
      items: ["Bug/issue", "Question", "Feature", "Improvement", "Other"],
      type: null,
      states: [
        "requested",
        "backlog",
        "in development",
        "ready for review",
        "done",
      ],
      message: "",
      menu: false,
      state: "requested",
      title: "",
      saving: false,
    };
  },
  methods: {
    async saveFeedback() {
      this.saving = true;
      const email = httpsCallable(functions, "email");

      if (
        this.type === "Bug/issue" ||
        this.type === "Feature" ||
        this.type === "Improvement"
      ) {
        const docRef = await addDoc(collection(db, "backlog"), {
          created_at: Math.floor(Date.now() / 1000),
          description: this.message,
          type: this.type,
          status: this.state,
          images: [],
          suggested_by: this.$store.state.users.userProfile.uid,
          title: this.title ? this.title : "",
          votes: [this.$store.state.users.userProfile.uid],
        });
        console.log("Document written with ID: ", docRef.id);

        const ref = doc(db, "backlog", docRef.id);

        await updateDoc(ref, {
          uid: docRef.id,
        });

        await email({
          email: [this.$store.state.users.userProfile.email],
          template: {
            name: "feedback_confirmation",
            data: {
              type: this.type,
              title: this.title,
              feedback: this.message,
              first_name: this.userProfile.first_name,
            },
          },
        });
      } else {
        await email({
          email: [this.$store.state.users.userProfile.email],
          template: {
            name: "feedback_confirmation",
            data: {
              type: this.type,
              title: this.title,
              feedback: this.message,
              first_name: this.userProfile.first_name,
            },
          },
        });
      }

      if (this.$store.state.users.userProfile.superadmin) {
        this.$store.dispatch("fetchAdminBacklog");
      }

      this.$store.commit("setNotification", {
        show: true,
        text: `Your ${this.type} is sent! Thanks!`,
        type: "primary",
        icon: "",
      });
      this.saving = false;
      this.menu = false;
      this.message = "";
      this.title = "";
      this.type = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.feed {
  margin: 0;
  position: fixed;
  bottom: 20%;
  right: -30px;
  -ms-transform: translateY(-50%) rotate(270deg);
  transform: translateY(-50%) rotate(270deg);
  z-index: 98;
}
</style>
